import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBitbot16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8.75 2.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M11.585 8.085a.915.915 0 0 0-.916.915H12.5a.915.915 0 0 0-.915-.915M4.583 8.087A.915.915 0 0 0 3.667 9H5.5a.915.915 0 0 0-.917-.913M8 11.334c.736 0 1.333-.597 1.333-1.334H6.667c0 .737.597 1.334 1.333 1.334" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M3.932 3.755a62 62 0 0 1 8.136 0c1.225.087 2.199 1.006 2.417 2.186.375 2.028.616 3.63.714 5.34A2.573 2.573 0 0 1 12.767 14c-2.795.162-6.74.162-9.534 0a2.573 2.573 0 0 1-2.432-2.72c.098-1.71.339-3.311.714-5.34.218-1.18 1.192-2.098 2.417-2.185m8.03 1.496a60 60 0 0 0-7.923 0c-.516.037-.95.426-1.05.963-.37 2.002-.598 3.534-.69 5.153-.035.596.414 1.1 1.02 1.135 2.738.159 6.624.159 9.361 0a1.073 1.073 0 0 0 1.021-1.135c-.093-1.619-.32-3.15-.69-5.153a1.16 1.16 0 0 0-1.05-.963",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconBitbot16);
export default ForwardRef;
